"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLink = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
exports.StyledLink = styled_components_1.default.a `
    outline: none;
    text-decoration: none;
    font: ${helpers_1.BASE_FONT};

    ${({ disabled, theme }) => (0, styled_components_1.css) `
        color: ${disabled ? theme.colorTextLight : theme.colorLink};
        cursor: ${disabled ? 'default' : 'pointer'};
        pointer-events: ${disabled ? 'none' : 'inherit'};
    `}

    ${({ disabled }) => !disabled &&
    (0, styled_components_1.css) `
            &:focus,
            &:hover {
                text-decoration: underline;
            }

            &:active {
                text-decoration: none;
            }
        `}

    ${({ truncate }) => truncate &&
    (0, styled_components_1.css) `
            max-width: 100%;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `}
`;
//# sourceMappingURL=Link.styles.js.map